import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./index.scss";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Host from "../../Components/Host";
import ReCAPTCHA from "react-google-recaptcha";
import { useFindOrderMutation, useVerifyMutation } from "../../services/track_order";
import OtpInput from "react-otp-input";
import Loader from "../../Components/Loader";
import HelmetComponent from "../../Components/HelmetComponent";
import { Tag } from "antd";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import Stepper from "@mui/joy/Stepper";
import Step, { stepClasses } from "@mui/joy/Step";
import StepIndicator, { stepIndicatorClasses } from "@mui/joy/StepIndicator";
import Typography from "@mui/joy/Typography";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import LocalMallIcon from "@mui/icons-material/LocalMall";
var moment = require("moment");

function TrackOrder() {
  const { countryCode } = useSelector((state) => state.auth);
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  const [findorder, findresult] = useFindOrderMutation();
  const [verifyotp, verifyresult] = useVerifyMutation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { handleSubmit: handleSubmit2 } = useForm();
  const recaptchaRef = React.useRef();
  const [isOtpCard, setOtpCard] = useState(false);
  const [isLoginCard, setLoginCard] = useState(true);
  const [otp, setOtp] = useState("");
  const [getToken, setToken] = useState("");
  const [isExpand, setExpand] = useState("");

  async function loginWithOtp() {
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    verifyotp({
      otp: otp,
      token: getToken,
      captcha_token: token,
      countryCode: countryCode,
      domain: Host?.domain,
      domainEmail: Host?.email,
    });
  }

  async function trackOrder(data) {
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    findorder({
      order_number: data.order_number,
      email: data.email,
      captcha_token: token,
      countryCode: countryCode,
      domain: window.location.hostname || Host?.domain,
      domainEmail: Host?.email,
    });
  }

  useEffect(() => {
    if (findresult?.isSuccess) {
      setToken(findresult?.data?.token);
      setLoginCard(false);
      setOtpCard(true);
    }
    if (verifyresult?.isSuccess) {
      setLoginCard(false);
      setOtpCard(false);
    }
    if (!verifyresult?.isSuccess) {
      if (!findresult?.isSuccess) {
        setLoginCard(true);
      }
    }
  }, [findresult, verifyresult]);

  function getDeliverydays(data, created) {
    if (Number(data) > 0) {
      return moment(created).add(Number(data), "days").format("dddd Do MMM YYYY");
    }
    return moment(created).add(10, "days").format("dddd Do MMM YYYY");
  }

  const order = verifyresult?.data?.order;

  const groupData = order?.order_items?.reduce((acc, obj) => {
    const key = obj.estimated_delivery;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});

  // ---------- Shipping status helpers (logic unchanged) ----------
  function getShippingStep(thisData) {
    const values = thisData?.split(",");
    if (values?.some((part) => part.includes("arrived"))) {
      return true;
    } else if (values?.some((part) => part.includes("departed"))) {
      return true;
    } else if (thisData.includes("out_for_delivery")) {
      return true;
    } else {
      return false;
    }
  }

  const getShippingStep1 = getShippingStep;

  const storeIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12, 26];
  function functionIdLink(id, pid, store_id) {
    if (storeIds?.includes(Number(store_id))) {
      return pid;
    } else {
      return id;
    }
  }
  function productTitle(title) {
    return title?.replace(/[^A-Za-z0-9]/g, " ")?.replace(/[^\w\s.,]/gi, " ")?.replace(/ /g, "-");
  }

  function getProcessing(status, arived, departed) {
    const processingState = ["dispatched", "arrived_in_US", "departed_from_US", "arrived_in_UK", "departed_from_UK", "arrived_in_IN", "departed_from_IN", "arrived_in_AE", "departed_from_AE", "out_for_delivery", "delivered"];
    const toFindArray = status?.split(",");
    if (toFindArray?.includes(arived)) {
      return true;
    } else if (toFindArray?.includes(departed)) {
      return true;
    } else {
      return processingState?.some((item) => toFindArray?.includes(item));
    }
  }

  function getDispatched(status, arived, departed) {
    const processingState = ["arrived_in_US", "departed_from_US", "arrived_in_UK", "departed_from_UK", "arrived_in_IN", "departed_from_IN", "arrived_in_AE", "departed_from_AE", "out_for_delivery", "delivered"];
    const toFindArray = status?.split(",");
    if (toFindArray?.includes(arived)) {
      return true;
    } else if (toFindArray?.includes(departed)) {
      return true;
    } else {
      return processingState.some((item) => toFindArray?.includes(item));
    }
  }

  function getShipping(status) {
    const processingState = ["out_for_delivery", "delivered"];
    const toFindArray = status?.split(",");
    return processingState.some((item) => toFindArray?.includes(item));
  }

  function getShipping2(status, curent) {
    const processingState = ["out_for_delivery", "delivered"];
    const toFindArray = status?.split(",");
    if (status?.split(",")?.includes(curent)) {
      return true;
    } else {
      return processingState.some((item) => toFindArray?.includes(item));
    }
  }

  function getShipping3(status, curent) {
    const processingState = ["out_for_delivery", "delivered", "arrived_in_india", "departed_from_india"];
    const toFindArray = status?.split(",");
    if (status?.split(",")?.includes(curent)) {
      return true;
    } else {
      return processingState.some((item) => toFindArray?.includes(item));
    }
  }

  // ---------- Step data ----------
  // Short 4-step progress bar shown on every item
  function getSummarySteps(it) {
    const processingDone = getProcessing(it.shipping_status, "arrived_in_india", "departed_from_india");
    const dispatchedDone = getDispatched(it.shipping_status, "arrived_in_india", "departed_from_india");
    const shippingDone = getShipping(it.shipping_status);
    const shippingStarted = getShippingStep(it.shipping_status);
    const delivered = it.shipping_state == "delivered";
    return [
      {
        label: "Processing",
        active: it.shipping_state == "processing",
        completed: processingDone,
        variant: processingDone || it.shipping_state == "processing" ? "solid" : "outlined",
        color: processingDone ? "success" : it.shipping_state == "processing" ? "warning" : "neutral",
        icon: processingDone ? <CheckCircleRoundedIcon style={{ fontSize: "20px" }} /> : <FiberManualRecordIcon style={{ fontSize: "20px" }} />,
      },
      {
        label: "Procuring",
        active: it.shipping_state == "dispatched",
        completed: dispatchedDone,
        variant: dispatchedDone || it.shipping_state == "dispatched" ? "solid" : "outlined",
        color: dispatchedDone ? "success" : it.shipping_state == "dispatched" ? "warning" : "neutral",
        icon: dispatchedDone ? <CheckCircleRoundedIcon style={{ fontSize: "20px" }} /> : <LocalMallIcon style={{ fontSize: "20px" }} />,
      },
      {
        label: "Shipping",
        active: getShippingStep1(it.shipping_state),
        completed: shippingDone,
        variant: shippingStarted || shippingDone ? "solid" : "outlined",
        color: shippingDone ? "success" : shippingStarted ? "warning" : "neutral",
        icon: shippingDone ? <CheckCircleRoundedIcon style={{ fontSize: "20px" }} /> : <LocalShippingRoundedIcon style={{ fontSize: "20px" }} />,
      },
      {
        label: "Delivered",
        active: false,
        completed: delivered,
        variant: delivered ? "solid" : "outlined",
        color: delivered ? "success" : "neutral",
        icon: <CheckCircleRoundedIcon style={{ fontSize: "20px" }} />,
      },
    ];
  }

  // Full step-by-step timeline shown under "Item tracking"
  function getDetailSteps(it) {
    const st = it.shipping_state;
    const ss = it.shipping_status;
    const has = (v) => ss?.split(",")?.includes(v);
    const isAE = it.country === "AE";
    const c = it.country;
    const pDone = getProcessing(ss, "arrived_in_india", "departed_from_india");
    const dDone = getDispatched(ss, "arrived_in_india", "departed_from_india");
    const shipDone = getShipping(ss);
    const shipStarted = getShippingStep(ss);

    const steps = [
      {
        key: "processing",
        label: "Processing",
        note: "Estimated 1 day",
        active: st == "processing",
        completed: pDone,
        variant: pDone || st == "processing" ? "solid" : "outlined",
        color: pDone ? "success" : st == "processing" ? "warning" : "neutral",
        content: pDone ? "check" : "1",
        enabled: st == "processing" ? true : pDone,
      },
      {
        key: "procuring",
        label: "Procuring",
        note: isAE ? "Estimated 1-2 days" : "Estimated 2-3 days",
        active: st == "dispatched",
        completed: dDone,
        variant: dDone || st == "dispatched" ? "solid" : "outlined",
        color: dDone ? "success" : st == "dispatched" ? "warning" : "neutral",
        content: dDone ? "check" : "2",
        enabled: st == "dispatched" ? true : dDone,
      },
      {
        key: "supplier",
        label: "Dispatched from supplier",
        active: st === "dispatched",
        completed: dDone,
        variant: st === "dispatched" ? "solid" : "outlined",
        color: dDone ? "success" : st === "dispatched" ? "warning" : "neutral",
        content: "dot",
        enabled: st == "dispatched" ? true : dDone,
      },
      {
        key: "shipping",
        label: "Shipping and fulfillment",
        note: isAE ? "Estimated 1-2 days" : "Estimated 3-5 days",
        active: getShippingStep1(st),
        completed: shipDone,
        variant: shipStarted || shipDone ? "solid" : "outlined",
        color: shipDone ? "success" : shipStarted ? "warning" : "neutral",
        content: shipDone ? "check" : "3",
        enabled: getShippingStep1(st) ? true : shipDone,
      },
    ];

    if (!isAE) {
      const arrCountryDone = getShipping3(ss, `departed_from_${c}`);
      const depCountryDone = getShipping3(ss, "arrived_in_india");
      steps.push(
        {
          key: "arr-country",
          label: `Arrived in ${c} warehouse`,
          active: st === `arrived_in_${c}`,
          completed: arrCountryDone,
          variant: st === `arrived_in_${c}` ? "solid" : "outlined",
          color: arrCountryDone ? "success" : has(`arrived_in_${c}`) ? "warning" : "neutral",
          content: "dot",
          enabled: st === `arrived_in_${c}` ? true : arrCountryDone,
        },
        {
          key: "dep-country",
          label: `Departed from ${c} warehouse`,
          active: st === `departed_from_${c}`,
          completed: depCountryDone,
          variant: st === `departed_from_${c}` ? "solid" : "outlined",
          color: depCountryDone ? "success" : has(`departed_from_${c}`) ? "warning" : "neutral",
          content: "dot",
          enabled: st === `departed_from_${c}` ? true : depCountryDone,
        }
      );
    }

    const arrIndiaDone = getShipping2(ss, "departed_from_india");
    steps.push(
      {
        key: "arr-india",
        label: "Arrived in India warehouse",
        active: st === "arrived_in_india",
        completed: arrIndiaDone,
        variant: st === "arrived_in_india" ? "solid" : "outlined",
        color: arrIndiaDone ? "success" : has("arrived_in_india") ? "warning" : "neutral",
        content: "dot",
        enabled: st === "arrived_in_india" ? true : arrIndiaDone,
      },
      {
        key: "dep-india",
        label: "Departed from India warehouse",
        active: st === "departed_from_india",
        completed: shipDone,
        variant: st === "departed_from_india" ? "solid" : "outlined",
        color: shipDone ? "success" : has("departed_from_india") ? "warning" : "neutral",
        content: "dot",
        enabled: st === "departed_from_india" ? true : shipDone,
      },
      {
        key: "out",
        label: "Out for delivery",
        active: st === "out_for_delivery",
        completed: st === "delivered",
        variant: st === "out_for_delivery" || st === "delivered" ? "solid" : "outlined",
        color: st === "delivered" ? "success" : st === "out_for_delivery" ? "warning" : "neutral",
        content: st === "delivered" ? "check" : "4",
        enabled: st === "out_for_delivery" ? true : st === "delivered",
      },
      {
        key: "delivered",
        label: "Delivered",
        note: isAE ? "Estimated 1-2 days" : "Estimated 2-3 days",
        active: false,
        completed: st == "delivered",
        variant: st == "delivered" ? "solid" : "outlined",
        color: st == "delivered" ? "success" : "neutral",
        content: st == "delivered" ? "check" : "5",
        enabled: st == "delivered",
      }
    );
    return steps;
  }

  function renderIndicator(content) {
    if (content === "check") return <CheckCircleRoundedIcon style={{ fontSize: "14px" }} />;
    if (content === "dot") return <FiberManualRecordIcon style={{ fontSize: "13px" }} />;
    return <span style={{ fontSize: "12px" }}>{content}</span>;
  }

  function renderStatus(it) {
    if (it.state === "cancelled") {
      return <span className="trk-pill is-danger">Cancelled</span>;
    }
    if (it.shipping_state === "delivered") {
      return (
        <span className="trk-pill is-success">
          {it.delivered_on ? `${t("DELIVERED ON")} ${moment(it.delivered_on).format("Do MMM YYYY HH:mm")}` : "Delivered"}
        </span>
      );
    }
    return <span className="trk-pill">{it.shipping_state?.replace(/_/g, " ")}</span>;
  }

  const summaryStepperSx = {
    width: "100%",
    "--StepIndicator-size": "2rem",
    "--Step-connectorInset": "0px",
    [`& .${stepIndicatorClasses.root}`]: { borderWidth: 2 },
    [`& .${stepClasses.root}::after`]: { height: 2 },
    [`& .${stepClasses.completed}`]: {
      "&::after": { bgcolor: "success.300" },
    },
    [`& .${stepClasses.active}`]: {
      [`& .${stepIndicatorClasses.root}`]: {
        border: "3px solid",
        borderColor: "#fff",
        boxShadow: (theme) => `0 0 0 1px ${theme.vars.palette.warning[500]}`,
      },
    },
    [`& .${stepClasses.disabled} *`]: { color: "neutral.outlinedDisabledColor" },
  };

  const detailStepperSx = {
    "--Stepper-verticalGap": "1.4rem",
    "--StepIndicator-size": "1.5rem",
    "--Step-gap": "1rem",
    "--Step-connectorInset": "0rem",
    "--Step-connectorRadius": "1rem",
    "--Step-connectorThickness": "1.5px",
    "--joy-palette-success-solidBg": "var(--joy-palette-success-400)",
    [`& .${stepClasses.completed}`]: { "&::after": { bgcolor: "success.solidBg" } },
    [`& .${stepClasses.active}`]: {
      [`& .${stepIndicatorClasses.root}`]: {
        border: "2px solid",
        borderColor: "#fff",
        boxShadow: (theme) => `0 0 0 1px ${theme.vars.palette.warning[500]}`,
      },
    },
  };

  function renderItems(data) {
    return (
      <div className="trk-groups">
        {groupData &&
          Object.entries(groupData).map(([group, groupItems]) => (
            <section key={group} className="trk-group">
              <header className="trk-group__head">
                <div>
                  Estimated delivery by <strong>{getDeliverydays(group, data?.createdAt)}</strong>
                </div>
                <span className="trk-group__count">
                  {groupItems?.length} {groupItems?.length === 1 ? "item" : "items"}
                </span>
              </header>

              {groupItems?.map((items, index) => {
                const link = `/product/${items.store_id}/${functionIdLink(items?.product_id, items?.pid, items?.store_id)}/${productTitle(items.title)}`;
                const open = isExpand === `open${items.id}`;
                return (
                  <article key={index} className="trk-item">
                    {items.state !== "cancelled" && (
                      <Stepper size="lg" sx={summaryStepperSx} className="trk-progress">
                        {getSummarySteps(items).map((s) => (
                          <Step
                            key={s.label}
                            active={s.active}
                            completed={s.completed}
                            orientation="vertical"
                            indicator={
                              <StepIndicator variant={s.variant} color={s.color}>
                                {s.icon}
                              </StepIndicator>
                            }
                          >
                            <Typography
                              sx={{ textTransform: "uppercase", fontWeight: "lg", fontSize: "0.68rem", letterSpacing: "0.5px" }}
                            >
                              {s.label}
                            </Typography>
                          </Step>
                        ))}
                      </Stepper>
                    )}

                    <div className="trk-item__row">
                      <Link to={link} className="trk-item__thumb">
                        <img className="trk-item__img" src={items.image} alt={items.title || "Product"} />
                      </Link>
                      <div className="trk-item__info">
                        <Link to={link} className="trk-item__title">
                          {items.title?.replace(/[^\w\s.,/:']/gi, " ")}
                        </Link>
                        <div className="trk-tags">
                          <Tag>Condition: {items.conditions}</Tag>
                          <Tag>Qty: {items.quantity}</Tag>
                          {items.current_variant &&
                            Object.entries(items.current_variant || []).map(([key, value], i) => (
                              <Tag key={i}>
                                <strong>{key}:</strong> {value}
                              </Tag>
                            ))}
                        </div>
                      </div>
                      <div className="trk-item__status">{renderStatus(items)}</div>
                    </div>

                    {items.state !== "cancelled" && (
                      <>
                        <button
                          type="button"
                          className="trk-toggle"
                          aria-expanded={open}
                          onClick={() => setExpand(open ? "" : `open${items.id}`)}
                        >
                          <span>Item tracking</span>
                          {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                        </button>

                        {open && (
                          <Stepper orientation="vertical" className="trk-timeline" sx={detailStepperSx}>
                            {getDetailSteps(items).map((s) => (
                              <Step
                                key={s.key}
                                active={s.active}
                                completed={s.completed}
                                indicator={
                                  <StepIndicator variant={s.variant} color={s.color}>
                                    {renderIndicator(s.content)}
                                  </StepIndicator>
                                }
                              >
                                <div className={`trk-event ${s.enabled ? "is-on" : "is-off"}`}>
                                  {s.note && <small>{s.note}</small>}
                                  <span>{s.label}</span>
                                </div>
                              </Step>
                            ))}
                          </Stepper>
                        )}
                      </>
                    )}
                  </article>
                );
              })}
            </section>
          ))}
      </div>
    );
  }

  const apiError = findresult?.error?.data?.error || verifyresult?.error?.data?.error;

  return (
    <>
      <HelmetComponent title={"Track order"} />

      <main className="track-page">
        <section className="trk-hero">
          <div className="trk-wrap">
            <nav className="trk-crumbs" aria-label="Breadcrumb">
              <a href="/">Home</a>
              <span aria-hidden="true">/</span>
              <span>Track order</span>
            </nav>
            <h1>{order ? t("Order Details") : t("Track your order")}</h1>
            {!order && <p>Enter your order number and email to see where your order is.</p>}
          </div>
        </section>

        <div className="trk-wrap trk-body">
          {/* ---------- Lookup / OTP ---------- */}
          {!order && (
            <div className="trk-card">
              {apiError && (
                <div className="trk-alert" role="alert">
                  {apiError}
                </div>
              )}

              {isLoginCard && (
                <form onSubmit={handleSubmit(trackOrder)} noValidate>
                  <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey="6LfD62EnAAAAAJ83k0BznR8m_cXInxBFjtTokspL" />
                  <div className="trk-field">
                    <label htmlFor="order_number">{t("Order Number")}</label>
                    <input
                      type="text"
                      id="order_number"
                      className={`trk-input ${errors.order_number ? "is-invalid" : ""}`}
                      aria-invalid={errors.order_number ? "true" : "false"}
                      {...register("order_number", { required: "Please enter your order number" })}
                    />
                    {errors.order_number && <small className="trk-error">{errors.order_number.message}</small>}
                  </div>
                  <div className="trk-field">
                    <label htmlFor="email">{t("email")}</label>
                    <input
                      type="email"
                      id="email"
                      autoComplete="email"
                      className={`trk-input ${errors.email ? "is-invalid" : ""}`}
                      aria-invalid={errors.email ? "true" : "false"}
                      {...register("email", { required: "Please enter your email" })}
                    />
                    {errors.email && <small className="trk-error">{errors.email.message}</small>}
                  </div>
                  <Button
                    disabled={findresult.isLoading}
                    className="trk-submit"
                    style={{ background: Host?.bgColor || "#bf9a5a", color: Host?.buttonColor || "#000" }}
                    variant="info"
                    type="submit"
                  >
                    {findresult.isLoading ? <Loader /> : t("submit")}
                  </Button>
                </form>
              )}

              {isOtpCard && (
                <form onSubmit={handleSubmit2(loginWithOtp)}>
                  <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey="6LfD62EnAAAAAJ83k0BznR8m_cXInxBFjtTokspL" />
                  <div className="trk-field trk-field--center">
                    <label>{t("Enter your OTP")}</label>
                    <OtpInput
                      inputStyle="trk-otp-input"
                      containerStyle="trk-otp"
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      renderSeparator={<span className="trk-otp-gap"></span>}
                      id="code"
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>
                  <Button
                    type="submit"
                    disabled={verifyresult?.isLoading}
                    className="trk-submit"
                    variant="info"
                    style={{ background: Host?.bgColor || "#bf9a5a", color: Host?.buttonColor || "#000" }}
                  >
                    {verifyresult?.isLoading ? <Loader /> : t("submit")}
                  </Button>
                </form>
              )}
            </div>
          )}

          {/* ---------- Order result ---------- */}
          {order && (
            <>
              <section className="trk-summary" aria-label="Order summary">
                <div>
                  <span>Order number</span>
                  <strong>{order?.order_number}</strong>
                </div>
                <div>
                  <span>{t("order_placed_on")}</span>
                  <strong>{moment(order?.createdAt).format("MMM Do YYYY")}</strong>
                </div>
                <div>
                  <span>Total items</span>
                  <strong>{order?.order_items?.length}</strong>
                </div>
                <div>
                  <span>Order status</span>
                  {order?.states === "cancelled" ? (
                    <em className="trk-pill is-danger">Cancelled</em>
                  ) : order?.status ? (
                    <em className="trk-pill is-success">Confirmed</em>
                  ) : (
                    <em className="trk-pill is-warn">Payment pending</em>
                  )}
                </div>
              </section>

              {renderItems(order)}
            </>
          )}
        </div>
      </main>
    </>
  );
}

export default TrackOrder;